import { React } from "react";
import "./style.css";

function DeleteRecordModal({
  handleDeleteRecord,
  deleteFunctionToUse,
  setShowDeleteDialog,
  idToDelete,
}) {
  return (
    <div className="modal-container" onClick={() => setShowDeleteDialog(false)}>
      <div
        className="container-delete-machine"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <h2 className="title-delete-machine">Are you sure ?</h2>
        <div className="form-wrapper">
          <div className="d-flex mt-3 justify-content-around">
            <button
              onClick={() => setShowDeleteDialog(false)}
              className="btn btn-primary waves-effect button-delete-machine"
            >
              Cancel
            </button>
            <button
              className="btn btn-danger waves-effect button-delete-machine"
              type="button"
              onClick={() => {
                handleDeleteRecord(idToDelete, deleteFunctionToUse);
                setShowDeleteDialog(false);
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteRecordModal;
